import React from 'react';
import { Form, Input } from 'antd';

const LinkInput = ({ disabled, handleChange } : any) => {

  return (
    <div style={{ width: '100%' }}>
        <Form.Item
          label="Link ( Please enter only youtube url )"
          name="link"
          colon={false}
          rules={[
            {
              type: 'url',
              message: 'Invalid link!',
            },
          ]}
        >
          <Input disabled={disabled} placeholder="Enter youtube link" onChange={(e: any)=> handleChange(e.target.value)} style={{ width: '100%' }} />
        </Form.Item>
    </div>
  );
};

export default LinkInput;